import React from 'react';
import Clipboard from 'clipboard';
import PropTypes from 'prop-types';
import InputElement from 'react-input-mask';
import { FormattedMessage } from 'react-intl';
import getFieldError from '../../utils/get-field-error';

export default class Input extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: `${this.props.name ? this.props.name : 'input'}_${Math.round(Math.random() * 99999)}`,
      validated: false,
      validateResult: false,
    };

    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (this.props.copy) {
      this.clipboard = new Clipboard(`#${this.state.id}_group .input__copy`);
    }
  }

  componentWillReceiveProps(props) {
    if (getFieldError(props.reduxStateAlternate ? [props.reduxStateAlternate, props.reduxState] : props.reduxState, this.getErrorName()) !== getFieldError(this.props.reduxStateAlternate ? [this.props.reduxStateAlternate, this.props.reduxState] : this.props.reduxState, this.getErrorName())) { // eslint-disable-line
      this.setState({
        validated: false,
        validateResult: false,
      });
    }
  }

  componentWillUnmount() {
    if (this.clipboard) {
      this.clipboard.destroy();
    }
  }

  getLabel() {
    let label = this.props.label;

    if (this.props.required && label) {
      label = `${label} *`;
    }

    return label;
  }

  getPlaceholder() {
    let placeholder = null;

    if (this.props.placeholder) {
      placeholder = this.props.placeholder;
    } else if (!this.props.hideLabel) {
      placeholder = this.getLabel();
    }

    return placeholder;
  }

  getErrorName() {
    let error = this.props.name;

    if (this.props.errorName) {
      error = this.props.errorName;
    }

    if (this.props.errorPrefix) {
      error = `${this.props.errorPrefix}${error}`;
    }

    if (this.props.activeParent || this.props.activeParent === '') {
      if (this.props.activeParent !== this.props.parent) {
        error = null;
      }
    }

    return error;
  }

  handleChange() {
    if (this.props.mask) {
      this.props.onChange(document.getElementById(this.state.id).value, this.props.name, this.props.parent);
    } else {
      this.props.onChange(this.inputRef.value, this.props.name, this.props.parent);
    }
  }

  handleBlur() {
    if (this.props.validate) {
      if (this.props.required) {
        if (this.props.value) {
          let validateResult = true;

          if (this.props.requiredMinLength && this.props.value.length < this.props.requiredMinLength) {
            validateResult = false;
          }

          if (this.props.requiredMaxLength && this.props.value.length > this.props.requiredMaxLength) {
            validateResult = false;
          }

          this.setState({
            validated: true,
            validateResult,
          });
        } else {
          this.setState({
            validated: true,
            validateResult: false,
          });
        }
      } else if (this.props.value) {
        this.setState({
          validated: true,
          validateResult: true,
        });
      }
    }
  }

  renderCopyButton() {
    return (
      <button className="input__copy button button--small" data-clipboard-target={`#${this.state.id}`}>
        <FormattedMessage id="general.copy" />
      </button>
    );
  }

  renderError() {
    let error = (
      <p className="input__error" />
    );

    if (getFieldError(this.props.reduxState, this.getErrorName())) {
      error = (
        <p className="input__error">{`errors.${getFieldError(this.props.reduxState, this.getErrorName())}`}</p>
      );
    }

    if (this.props.messages && this.props.messages[`errors.${getFieldError(this.props.reduxState, this.getErrorName())}`]) {
      error = (
        <p className="input__error">{this.props.messages[`errors.${getFieldError(this.props.reduxState, this.getErrorName())}`]}</p>
      );
    }

    if (this.state.validated && this.state.validateResult) {
      error = (
        <p className="input__error" />
      );
    }

    return error;
  }

  renderInput(className) {
    return (
      <input
        autoCapitalize={this.props.autoCapitalize}
        id={this.state.id}
        type={this.props.type ? this.props.type : 'text'}
        value={this.props.value}
        name={this.props.name}
        className={className}
        ref={(e) => { this.inputRef = e; }}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        placeholder={this.getPlaceholder()}
        pattern={this.props.number ? '[0-9]*' : null}
        disabled={this.props.disabled}
      />
    );
  }

  renderLabel() {
    return (
      <label htmlFor={this.state.id}>{this.getLabel()}</label>
    );
  }

  renderMaskedInput(className) {
    return (
      <InputElement
        id={this.state.id}
        type={this.props.type ? this.props.type : 'text'}
        name={this.props.name}
        defaultValue={this.props.value}
        className={className}
        ref={(e) => { this.inputRef = e; }}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        placeholder={this.getPlaceholder()}
        pattern={this.props.number ? '[0-9]*' : null}
        mask={this.props.mask}
        maskChar={null}
        disabled={this.props.disabled}
      />
    );
  }

  renderTextarea(className) {
    return (
      <textarea
        id={this.state.id}
        value={this.props.value}
        name={this.props.name}
        className={className}
        ref={(e) => { this.inputRef = e; }}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        placeholder={this.getPlaceholder()}
        disabled={this.props.disabled}
      />
    );
  }

  renderValidationCheck() {
    let validationCheck;

    if (this.state.validated && this.state.validateResult) {
      validationCheck = (
        <span className="input__check icon-check" />
      );
    } else {
      validationCheck = (
        <span className="input__check icon-check input__check--hidden" />
      );
    }

    return validationCheck;
  }

  render() {
    const tagClass = this.props.type === 'textarea' ? 'textarea' : 'input';

    let className = `${tagClass}__native`;

    if (getFieldError(this.props.reduxStateAlternate ? [this.props.reduxStateAlternate, this.props.reduxState] : this.props.reduxState, this.getErrorName())) { // eslint-disable-line
      className += ` ${tagClass}__native--has-error`;
    }

    if (this.state.validated) {
      if (this.state.validateResult) {
        className += ` ${tagClass}__native--has-good-validation`;
      } else {
        className += ` ${tagClass}__native--has-bad-validation`;
      }
    }

    if (this.props.cssModifiers && this.props.cssModifiers.length) {
      this.props.cssModifiers.forEach((cssModfier) => {
        className += ` ${tagClass}__native--${cssModfier}`;
      });
    }

    let input;

    if (this.props.type === 'textarea') {
      input = this.renderTextarea(className);
    } else if (this.props.mask) {
      input = this.renderMaskedInput(className);
    } else {
      input = this.renderInput(className);
    }

    let parentClassName = 'input';

    if (this.props.parentCssModifiers && this.props.parentCssModifiers.length) {
      this.props.parentCssModifiers.forEach((cssModfier) => {
        parentClassName += ` input--${cssModfier}`;
      });
    }

    return (
      <div className={parentClassName} id={`${this.state.id}_group`}>
        {this.props.hideLabel ? null : this.renderLabel()}
        <div className="input__wrapper">
          {input}
          {this.props.copy ? this.renderCopyButton() : null}
          {this.props.validate ? this.renderValidationCheck() : null}
        </div>
        {this.props.noError ? null : this.renderError()}
      </div>
    );
  }
}

Input.defaultProps = {
  autocapitalize: 'off',
};

Input.propTypes = {
  autoCapitalize: PropTypes.string,
  onChange: PropTypes.func,
  messages: PropTypes.object,
  reduxState: PropTypes.object,
  reduxStateAlternate: PropTypes.object,
  name: PropTypes.string,
  errorName: PropTypes.string,
  errorPrefix: PropTypes.string,
  parent: PropTypes.string,
  activeParent: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  parentCssModifiers: PropTypes.array,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  mask: PropTypes.string,
  number: PropTypes.bool,
  validate: PropTypes.bool,
  required: PropTypes.bool,
  requiredMinLength: PropTypes.number,
  requiredMaxLength: PropTypes.number,
  hideLabel: PropTypes.bool,
  noError: PropTypes.bool,
  disabled: PropTypes.bool,
  copy: PropTypes.bool,
  cssModifiers: PropTypes.array,
};



// WEBPACK FOOTER //
// ./~/bgr-react-input/js/components/input/index.jsx